(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-scent-rotation"]) return;
  try {
    
if (!customElements.get('scent-rotation')) {
  customElements.define('scent-rotation', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.error = this.querySelector('.rotation__error');
      this.currency = this.dataset.currency;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.currency, minimumFractionDigits: 2 });
      for (const price of this.querySelectorAll('[data-group-price]')) price.textContent = this.money.format(Number(price.dataset.groupPrice) / 100);
      this.form.addEventListener('change', event => { if (event.target.name === 'id') this.select(); });
      this.form.addEventListener('submit', event => this.submit(event));
      this.select(false);
    }
    select(updateUrl = true) {
      const choice = this.form.querySelector('input[name="id"]:checked');
      if (!choice) return;
      this.form.elements.selling_plan.value = choice.dataset.plan;
      this.querySelector('[data-price-output]').textContent = this.money.format(Number(choice.dataset.price) / 100);
      const founding = this.querySelector('[data-founding]');
      if (founding) founding.textContent = this.money.format(Math.max(0, Number(choice.dataset.price) - 500) / 100);
      for (const visual of this.querySelectorAll('[data-visual]')) visual.hidden = visual.dataset.visual !== choice.value;
      this.button.disabled = choice.disabled || !choice.dataset.plan || this.busy;
      this.error.hidden = true;
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', choice.value);
        window.history.replaceState({}, '', url);
      }
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      const choice = this.form.querySelector('input[name="id"]:checked');
      if (!choice || choice.disabled || !choice.dataset.plan) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.working;
      this.error.hidden = true;
      const root = this.dataset.root;
      let added = false;
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(choice.value), quantity: 1, selling_plan: Number(choice.dataset.plan) }] })
        });
        added = response.ok;
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        added = true;
        window.location.assign(root + 'discount/OLFATICFOUNDING?redirect=' + encodeURIComponent(root + 'checkout'));
      } catch (error) {
        this.error.textContent = error.message || this.dataset.error;
        this.error.hidden = false;
        if (added) {
          window.location.assign(root + 'checkout?discount=OLFATICFOUNDING');
          return;
        }
        this.busy = false;
        this.button.disabled = false;
        this.button.textContent = this.dataset.button;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
